// extracted by mini-css-extract-plugin
export default {"ChannelImageContainer":"ChannelLogo_ChannelImageContainer__2H-FY","ChannelImage":"ChannelLogo_ChannelImage__YT1FS","UploadIcon":"ChannelLogo_UploadIcon__iHsUo"};